import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../assets/logo.png';
import FooterImg from '../assets/footer-img.jpeg';
import ScrollToTop from 'react-scroll-to-top';
import RateUs from '../assets/rateus.jpeg';


const Footer = () => {

  const handleShare = () => {
    const currentUrl = 'https://omanshitravels.com';
    const shareText = "Omanshi Travels ✈. Check out the leading Tours & Travels company in Prayragraj. Offers, discounts, affordable prices, and much more!";

    // If the browser supports the share API (usually mobile browsers or modern browsers)
    if (navigator.share) {
      navigator.share({
        title: document.title,  // Share the page title
        text: shareText,  // Optional text to share
        url: currentUrl,  // The URL of the site
      }).catch((error) => {
        console.error("Error sharing:", error);
      });
    } else {
      // Fallback: Open the social media platforms manually in a new window
      const encodedUrl = encodeURIComponent(currentUrl);
      const encodedText = encodeURIComponent(shareText);
      const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      const twitterUrl = `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
      const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${document.title}&summary=${encodedText}`;
      const whatsappUrl = `https://wa.me/?text=${encodedText} ${encodedUrl}`;

      const shareWindow = window.open('', '_blank');
      shareWindow.document.write(`
        <html>
          <head><title>Share</title></head>
          <body>
            <h3>Share the site</h3>
            <ul>
              <li><a href="${facebookUrl}" target="_blank">Share on Facebook</a></li>
              <li><a href="${twitterUrl}" target="_blank">Share on Twitter</a></li>
              <li><a href="${linkedinUrl}" target="_blank">Share on LinkedIn</a></li>
              <li><a href="${whatsappUrl}" target="_blank">Share on WhatsApp</a></li>
            </ul>
          </body>
        </html>
      `);
      shareWindow.document.close();
    }
  };


  return (
    <>

      <ScrollToTop smooth className='scroll-to-top' viewBox="0 0 448 512"
        svgPath="M201.4 137.4c12.5-12.5 32.8-12.5 45.3 0l160 160c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 205.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l160-160z" />

      <footer className='bg-dark pt-5 pb-2 text-white'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <div className='d-flex'>
                <img src={Logo} className='img-fluid bg-white px-3 me-2' alt='site logo' style={{ height: '6em' }} />
                <img src={FooterImg} className='img-fluid bg-white py-1 px-1' alt='site logo' style={{ height: '6em' }} />
              </div>
              <p className='mt-3 mb-2'>Omanshi Travels is the leading Tours & Travels company/ service provider in Prayagraj offering travel packages,
                group tours, adventure trips, and corporate travel, we prioritize customer satisfaction.</p>
              <p className='my-0 animate__animated animate__flash animate__slow animate__infinite'>
                <Link className='nav-text text-warning' to='/'>माघ मेला 2026 <i class="fa-solid fa-sun fa-spin"></i></Link></p>

              <div className='d-flex mt-3'>
                <img src={RateUs} onClick={() => window.open('https://maps.app.goo.gl/D3kcD8DUiMa9ig9r8', '_blank')}
                  className='col-2 cursor-pointer' />
                <p className='fw-semibold ms-2'>Enjoyed Tour?<br />Rate Us!</p>
              </div>

            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <p className='sec-subheading'>Useful Links</p>
              <Link className='footer-link' to='/'>Home</Link><br /><br />
              <Link className='footer-link' to='/about'>About</Link><br /><br />
              <Link className='footer-link' to='/destination-gallery'>Destination Gallery</Link><br /><br />
              <Link className='footer-link' to='/tour-booking'>Tour Booking</Link><br /><br />
              <Link className='footer-link' to='/contact'>Contact</Link>
            </div>

            <div className='col-lg-4 col-md-6 col-12 my-3'>
              <p className='sec-subheading'>Contact Us</p>
              <i class="fa-solid fa-location-dot"></i> myohol road near shivam paints, manmohan park old katra Prayagraj 211002<br /><br />
              <Link className='footer-link' to='tel:8726359735'><i class="fa-solid fa-phone"></i> 8726359735</Link><br />
              {/* <Link className='footer-link' to='tel:8858633908'> 8858633908</Link> */}
              <br /><br />
              <Link className='footer-link' to='mailto:travelsomanshi@gmail.com'><i class="fa-solid fa-envelope"></i> travelsomanshi@gmail.com</Link><br /><br />
              <Link className='slider-btn px-3 py-2 rounded-pill' onClick={handleShare}>Share this Site <i className="fa-solid fa-share"></i></Link>

            </div>

          </div>
          {/* row ends */}

        </div>

        <hr />

        <div className='d-flex justify-content-between text-white px-lg-5 px-3'>
          <p>Copyright &copy; Omanshi Travels. All Rights Reserved.</p>
          <p>Developed By <Link className='footer-link' to='https://dectwinservices.com'>Dectwin Services Pvt Ltd</Link></p>
        </div>

      </footer>
    </>
  )
}

export default Footer
